export default {
  items: null,
  loading: false,
  currentProductgroup: '',
  currentParentgroup: '',
}